import { RoomModerationInfoCollection } from "@lifeat/shared/data-models/Rooms/RoomModerationTypes";
import * as ArgumentUtil from "@lifeat/shared/util/ArgumentUtil";
import { db } from "@firebase-local/firebase";

export function getAllRoomMembersRef(roomId: string, numMembers: number) {
    ArgumentUtil.validateRoomId(roomId);
    return db
        .ref(RoomModerationInfoCollection.at(roomId).at("allRoomMembersInfo").at("roomMembers").node.path)
        .limitToLast(numMembers);
}

export function getMutedRoomMembersRef(roomId: string, numMembers: number) {
    ArgumentUtil.validateRoomId(roomId);
    return db
        .ref(RoomModerationInfoCollection.at(roomId).at("allRoomMembersInfo").at("roomMembers").node.path)
        .orderByChild("isMutedByHost")
        .equalTo(true)
        .limitToLast(numMembers);
}

export function getInteractionBlockedMembersRef(roomId: string, numMembers: number) {
    ArgumentUtil.validateRoomId(roomId);
    return db
        .ref(RoomModerationInfoCollection.at(roomId).at("reportedUsers").node.path)
        .orderByChild("isInteractingBlocked")
        .equalTo(true)
        .limitToLast(numMembers);
}

export function getBannedRoomMembersRef(roomId: string, numMembers: number) {
    ArgumentUtil.validateRoomId(roomId);
    return db
        .ref(RoomModerationInfoCollection.at(roomId).at("allRoomMembersInfo").at("roomMembers").node.path)
        .orderByChild("isBannedByHost")
        .equalTo(true)
        .limitToLast(numMembers);
}

export function getAllMembersCountRef(roomId: string) {
    ArgumentUtil.validateRoomId(roomId);
    return db.ref(RoomModerationInfoCollection.at(roomId).at("allRoomMembersInfo").at("roomMemberCount").node.path);
}
